import Layout from '@/components/Layout';
import Header from '@/_content/blocks/prices/Header.mdx';
import Footer from '@/_content/blocks/prices/Footer.mdx';

import * as fs from 'fs';
import * as path from 'path';
import matter from 'gray-matter';
import unified from 'unified';
import markdown from 'remark-parse';
import html from 'remark-html';
import breaks from 'remark-breaks';
import PriceBlock from '@/components/prices/PriceBlock';
import useConfig from '@/hooks/useConfig';
import Meta from '@/components/Meta';

import { IPriceBlock } from '@/components/prices/IPriceBlock';

export interface IPrices {
  regular: IPriceBlock[];
  refsheets: IPriceBlock[];
}

export interface ICommissionInfoPageOpts {
  prices: IPrices;
}

export default function CommissionInfoPage({ prices: { regular, refsheets } }: ICommissionInfoPageOpts) {
  const { t } = useConfig();

  return (
    <Layout>
      <Meta title={t('prices.meta.title')} description={t('prices.meta.description')} />

      <div style={{ textAlign: 'center' }}>
        <Header />
      </div>
      <hr />

      {regular && regular.map(block => <PriceBlock key={block.name} block={block} />)}

      <h2>Reference Sheets</h2>

      {refsheets && refsheets.map(block => <PriceBlock key={block.name} block={block} />)}

      <div className="footer">
        <Footer />
      </div>

      <style jsx>{`
        .footer {
          text-align: center;
          font-size: 0.9em;
          color: #777;
        }
      `}</style>
    </Layout>
  );
}

export async function getStaticProps(ctx) {
  const entriesPath = path.join(process.cwd(), '_content/blocks/prices/entries');
  const files = fs.readdirSync(entriesPath, { encoding: 'utf8' })
    .filter(f => f.endsWith('.md'));

  const prices: IPrices = {
    regular: [],
    refsheets: []
  };

  for (let i = 0; i < files.length; i++) {
    const file = files[i];

    const filePath = path.join(entriesPath, file);
    const raw = fs.readFileSync(filePath, { encoding: 'utf8' });

    const { data, content } = matter(raw);

    const result = await unified()
      .use(markdown)
      .use(breaks)
      .use(html)
      .process(content);

    const body = result.toString();

    if (data.refsheet) {
      prices.refsheets.push({
        ...(data as IPriceBlock),
        body
      });
    } else {
      prices.regular.push({
        ...(data as IPriceBlock),
        body
      });
    }
  }

  prices.regular = prices.regular.sort((a, b) => a.order - b.order);
  prices.refsheets = prices.refsheets.sort((a, b) => a.order - b.order);

  return {
    props: { prices }
  };
}
